module.exports = __webpack_public_path__ + "assets/img/1.7b66497e.png";